export default "__VITE_ASSET__DLcxG3xU__"